import KeyWords from './KeyWords';

export default KeyWords;
